module.exports = __webpack_public_path__ + "static/img/weather_020.c96a8238.svg";